class ProductCarousel {
  static selectors = {
    primary: '[data-carousel-primary]',
    navigation: '[data-carousel-navigation]'
  }

  static defaultPrimaryOptions = {
    arrows: true,
    pagination: true,
    autoplay: false,
    interval: 3000,
    perMove: 1,
    perPage: 1,
    gap: 0,
    type: 'fade',
    rewind: false,
    speed: 1000,
    drag: true,
    snap: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    useIndex: true,
  }

  static defaultNavigationOptions = {
    arrows: false,
    pagination: false,
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: 16,
    isNavigation: true,
    updateOnMove: true,
    focus: 0,
    useIndex: true,
  }

  constructor(element, primaryOptions = {}, navigationOptions = {}, hasVariants = false) {
    this.element = element
    this.hasVariants = hasVariants
    this.id = element.dataset.carouselId
    this.elements = this.#getElements()
    this.primaryCarousel = null
    this.navigationCarousel = null
    this.variantImages = new Map()
    this.hasVariantImages = false

    this.loopArray = []
    this.primarySlides = []
    this.navigationSlides = []

    this.primaryOptions = {
      ...ProductCarousel.defaultPrimaryOptions,
      ...primaryOptions
    }

    this.navigationOptions = {
      ...ProductCarousel.defaultNavigationOptions,
      ...navigationOptions
    }

    if (this.hasVariants) {
      this.#getVariantImages()
      this.hasVariantImages = [...this.variantImages.values()].every(image => image !== null)
    }
  }

  #getVariantImages() {
    const variantImages = document.querySelector('[data-variant-images]')
    const variantImagesData = JSON.parse(variantImages.textContent)

    for (const [variantId, variantImages] of Object.entries(variantImagesData)) {
      this.variantImages.set(variantId, variantImages)
    }
  }

  #getElements() {
    return {
      primary: this.element.querySelector(ProductCarousel.selectors.primary),
      navigation: this.element.querySelector(ProductCarousel.selectors.navigation)
    }
  }

  #updateSlideImages(id) {
    const urls = this.variantImages.get(id.toString())

    this.loopArray.forEach((item, index) => {
      this.primarySlides[index].querySelector('img').src = urls[index]
      this.navigationSlides[index].querySelector('img').src = urls[index]
    })
  }

  #moveToVariantImage(index) {
    this.primaryCarousel.go(index - 1)
  }

  init() {
    this.primaryCarousel = new Splide(this.elements.primary, this.primaryOptions)
    this.navigationCarousel = new Splide(this.elements.navigation, this.navigationOptions)

    this.primaryCarousel.sync(this.navigationCarousel)

    this.primaryCarousel.on('mounted', () => {
      this.primarySlides = this.primaryCarousel.Components.Elements.slides
      this.loopArray = [...Array(this.primarySlides.length).keys()]
    })

    this.navigationCarousel.on('mounted', () => {
      this.navigationSlides = this.navigationCarousel.Components.Elements.slides
    })

    this.primaryCarousel.mount()
    this.navigationCarousel.mount()

    if (this.hasVariants) {
      window.addEventListener('variant:changed', (e) => {
        if (this.hasVariantImages) {
          this.#updateSlideImages(e.detail.id)
        } else {
          this.#moveToVariantImage(e.detail.index)
        }
      })
    }
  }
}

export default ProductCarousel